import ResizeColumn from './components/ResizeColumn';
export default function ColumnResizeProvider(components) {
  components.onGetComponent('cell-inner', function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cellType = context.cellType;

    if (cellType === 'input-cell' || cellType === 'output-cell' || cellType === 'annotations') {
      return ResizeColumn;
    }
  });
}
ColumnResizeProvider.$inject = ['components'];
//# sourceMappingURL=ColumnResizeProvider.js.map